export const TRANSITION_DURATION = 300
export const AVATAR_SIZE = 50
export const PROXY_RADIUS = 10
export const LOCATION_RADIUS = 5
/** Side of a cloud location's box (`drawCloudPlace`), and of the cloud's icon in it. */
export const CLOUD_PLACE_SIZE = 36
export const CLOUD_PLACE_ICON = 34
export const SERVICE_LINK_SIZE = 3
export const SERVICE_TERMINAL_SIZE = 6
export const EXPANDED_SIZE_MULTIPLIER = 3
export const TEXT_OFFSET = 30
/** The rounded square of a graph node that has no glyph of its own. */
export const SQUARE_SIZE = 10
export const ROUNDED_TRIANGLE_PATH =
  'M11.2562 2.29014C12.5329 0.279936 15.4666 0.279934 16.7432 2.29014L25.7951 16.5432C27.1693 18.707 25.6149 21.5356 23.0516 21.5356H4.9478C2.38458 21.5356 0.830151 18.707 2.20431 16.5432L11.2562 2.29014Z'
export const SHIELD_PATH =
  'M12 0C12 0 11.9928 0 11.9856 0C7.72199 0.0806599 3.43679 1.32722 0 3.38039C0.129419 7.44271 1.23667 11.4904 3.43679 15.2227C5.67286 19.0137 8.45536 21.9688 11.9856 23.9927C11.9856 23.9927 11.9928 23.9927 12 24C15.5374 21.9762 18.3271 19.0211 20.5632 15.2227C22.7633 11.4904 23.8706 7.44271 24 3.38039C20.556 1.32722 16.2708 0.0806599 12 0Z'
